var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M32 33h2v-2h-2zM36 33h2v-2h-2zM40 33h2v-2h-2zM38 49h2v-2h-2zM42 49h2v-2h-2zM46 49h2v-2h-2zM44 33h14v-2H44zM22 49h14v-2H22z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 61a1 1 0 01-.707-.293l-14-14a.999.999 0 010-1.414l14-14A1 1 0 0124 32v7h33a1 1 0 011 1v5.586L69.586 34 58 22.414V28h-2v-8a1 1 0 011.707-.707l14 14a.999.999 0 010 1.414l-14 14A.998.998 0 0156 48v-7H23a1 1 0 01-1-1v-5.586L10.414 46 22 57.586V52h2v8a1 1 0 01-1 1",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 72a31.875 31.875 0 01-17.223-5.024c-.43-.099-.777-.476-.777-.937V64h2v1.383A29.883 29.883 0 0040 70c16.542 0 30-13.458 30-30h2c0 17.645-14.355 32-32 32M10 40H8C8 22.355 22.355 8 40 8a31.878 31.878 0 0117.223 5.024c.431.099.777.476.777.937V16h-2v-1.383A29.883 29.883 0 0040 10c-16.542 0-30 13.458-30 30",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationExchange;